import React from "react";
import { Grid } from "@chakra-ui/react";
import OnboardingLayout from "./OnboardingLayout";
import OnboardingCard from "../Cards/OnboardingCard";

interface LanguageStepProps {
  language: string;
  setLanguage: (language: string) => void;
}

const LanguageStep: React.FC<LanguageStepProps> = ({ language, setLanguage }) => {
  const languages = [
    { flag: "🇪🇸", language: "Spanish", learnerCount: "24.2M", disabled: false },
    { flag: "🇫🇷", language: "French", disabled: true },
    { flag: "🇮🇹", language: "Italian", disabled: true },
    { flag: "🇬🇧", language: "English", disabled: true },
  ];

  return (
    <OnboardingLayout
      title="What language do you want to learn?"
      subtitle="Join the millions of people learning languages around the world."
    >
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={4}
        alignItems={"center"}
        justifyItems={"center"}
        maxW="600px"
        margin="0 auto"
      >
        {languages.map((lang, index) => (
          <OnboardingCard
            key={index}
            emoji={lang.flag}
            title={lang.language}
            disabled={lang.disabled}
            learnerCount={lang.learnerCount}
            selected={language === lang.language}
            onClick={() => !lang.disabled && setLanguage(lang.language)}
          />
        ))}
      </Grid>
    </OnboardingLayout>
  );
};

export default LanguageStep;
